import React from 'react';
import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { useResizablePanels } from './context';

export interface ResizablePanelsPanelProps extends BoxProps {
  index: number;
}

export const ResizablePanelsPanel: React.FC<ResizablePanelsPanelProps> = ({
  children,
  index,
  className,
  ...boxProps
}) => {
  const { panelWidths, minWidths, maxWidths } = useResizablePanels();

  if (index < panelWidths.length) {
    return (
      <Box
        width={`${panelWidths[index]}px`}
        height="100%"
        minWidth={`${minWidths[index] ?? 100}px`}
        maxWidth={maxWidths?.[index] ? `${maxWidths[index]}px` : undefined}
        overflow="hidden"
        flexShrink={0}
        className={`ResizablePanelsPanel ${className ?? ''}`}
        {...boxProps}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      flex={1}
      height="100%"
      overflow="hidden"
      className={`ResizablePanelsPanel ${className ?? ''}`}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
